import styled from 'styled-components';

import { Tag } from 'components/ui';

export const FuturePropagationTag = styled(Tag)<{ $color: string }>`
  && {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border-color: ${({ $color }) => $color};
    color: ${({ $color }) => $color};
    max-width: 100%;
    white-space: normal;
  }
`;

export const TooltipLine = styled.div`
  & + & {
    margin-top: 6px;
  }
`;

export const PredictionTableScroll = styled.div`
  overflow-x: auto;
`;

export const PredictionTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 4px 8px;
    text-align: right;
    white-space: nowrap;
  }

  th:first-child,
  td:first-child {
    text-align: left;
    padding-left: 0;
  }

  thead th {
    font-weight: 600;
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  }

  tbody tr + tr > * {
    border-top: 1px solid ${({ theme }) => theme.borderColor};
  }
`;

export const ForecastRowHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
`;

export const ForecastLabel = styled.div`
  color: ${({ theme }) => theme.textColor};
`;

export const ForecastDate = styled.div`
  font-weight: 400;
  color: ${({ theme }) => theme.secondaryTextColor};
`;

export const ProbabilityValue = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-variant-numeric: tabular-nums;
`;
